module.exports = __webpack_public_path__ + "static/media/arrow.5079224d.svg";